import React from 'react';
import styles from 'app/home/hierarchy/HierarchyPanel.styles';
import { useHomeContext } from 'app/home/context';
import { Box, IconButton } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';

interface HierarchySectionProps {
    type: string;
    label: string;
    icon: string;
    dataTest: string;
    children?: any;
    actionMenu?: React.JSX.Element;
    isMenuActive?: boolean;
}
export default function HierarchySection(props: HierarchySectionProps) {
    const { label, icon, dataTest, actionMenu, isMenuActive, type } = props;
    const ctx = useHomeContext();
    const homePageState = ctx.homePageState;

    const isCollapsed = homePageState?.collapsedSections?.[type];
    const isActiveSection = homePageState.filterState.folderSelected.split('_')[0] == type;

    const toggleCollapse = () => {
        let state = { ...homePageState };
        if (undefined === state.collapsedSections) state.collapsedSections = {};
        if (undefined === state.collapsedSections[type]) state.collapsedSections[type] = true;
        else state.collapsedSections[type] = !state.collapsedSections[type];

        ctx.setHomePageState(state);
    };

    return (
        <Box sx={styles.hierarchySection} className={'hierarchy-section'}>
            <Box
                sx={styles.hierarchySectionHeading}
                data-test={dataTest}
                className={`hierarchy-section__heading ${isActiveSection ? 'hierarchy-section__heading--active-child' : ''} ${isMenuActive ? 'section-action-menu-active' : ''}`}
                onClick={toggleCollapse}
            >
                <Box sx={styles.hierarchySectionHeadingIcon} className={'hierarchy-section__icon'}>
                    <IconMi icon={icon} fontSize={'16'} />
                </Box>
                <Box sx={styles.hierarchySectionHeadingLabel} className={'hierarchy-section__label'}>
                    <Box sx={styles.hierarchySectionHeadingLabelAlign}>{label}</Box>
                </Box>
                <Box
                    sx={styles.hierarchySectionHeadingActionHolder}
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                    className={'section-action-menu-holder'}
                >
                    {actionMenu && (
                        <Box className={'section-action-menu'} sx={styles.hierarchySectionHeadingActionMenuBtn}>
                            {actionMenu}
                        </Box>
                    )}
                    <Box>
                        <IconButton onClick={toggleCollapse} sx={styles.hierarchySectionHeadingCollapseBtn}>
                            <IconMi icon={isCollapsed ? 'chevron-down' : 'chevron-up'} fontSize="16" />
                        </IconButton>
                    </Box>
                </Box>
            </Box>
            <Box
                sx={styles.hierarchySectionItems}
                className={`hierarchy-section__items ${isCollapsed ? 'hierarchy-section__items--collapsed' : ''}`}
            >
                {props.children}
            </Box>
        </Box>
    );
}
